import { render, staticRenderFns } from "./Clone.vue?vue&type=template&id=abe198ac"
import script from "./Clone.vue?vue&type=script&lang=ts"
export * from "./Clone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports